import React from 'react';

import { Typography } from '@gogame/components';
import { DateRangeFormatter, rangePresets } from '@gogame/intl-ts';

const DateRangeView = ({ period = {} } = {}) => {
  if (period.id === 'CUSTOM') {
    return (
      <Typography>
        <DateRangeFormatter
          value={[period.fromDate, period.toDate]}
          template={'LL'}
          timeZone={'utc'}
        />
      </Typography>
    );
  } else {
    return (
      <Typography>
        {rangePresets[period.id]
          ? rangePresets[period.id].label
          : period.id
            ? period.id
            : null}
      </Typography>
    );
  }
};

export default DateRangeView;
